

export const selectTotalBalance = state => state.finance?.totalBalance ?? 0;
